"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hindiTranslations = void 0;
var _types = require("../../../types");
const hindiTranslations = exports.hindiTranslations = {
  [_types.ErrorPageTranslationKey.headline]: 'बहुत अफसोस!',
  [_types.ErrorPageTranslationKey.buttonText]: 'पीछे',
  [_types.ErrorPageTranslationKey.text]: 'यह पेज फिलहाल ख़राब है',
  [_types.ErrorPageTranslationKey.notFound]: 'आप जिस पृष्ठ की तलाश कर रहे हैं वह उपलब्ध नहीं है',
  [_types.ErrorPageTranslationKey.unauthorized]: 'आप जिस पृष्ठ तक पहुंचने का प्रयास कर रहे हैं वह प्रतिबंधित है और सभी मानदंड पूरे नहीं किए गए हैं।',
  [_types.ErrorPageTranslationKey.contactSupportTeam]: 'कृपया ईमेल द्वारा ओरिफ्लेम सहायता टीम से संपर्क करें:',
  [_types.ErrorPageTranslationKey.rejectedUrl]: 'अनुरोधित यूआरएल अस्वीकार कर दिया गया था!'
};
